var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChatIcon = function SvgChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chatIcon_svg__a)",
    fillRule: "evenodd",
    d: "M33 3H3v21h30V3ZM3 0a3 3 0 0 0-3 3v31l6.222-7H33a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3Zm5.5 6a1.5 1.5 0 1 0 0 3h20a1.5 1.5 0 0 0 0-3h-20ZM7 13.5A1.5 1.5 0 0 1 8.5 12h20a1.5 1.5 0 0 1 0 3h-20A1.5 1.5 0 0 1 7 13.5ZM8.5 18a1.5 1.5 0 0 0 0 3h13a1.5 1.5 0 0 0 0-3h-13Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatIcon_svg__a",
    x1: 6.289,
    x2: 28.011,
    y1: 2.773,
    y2: 3.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#F0CAB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC836D"
  })))));
};
export default SvgChatIcon;